import type { PartnerFeatureFlag } from '@fukuri-admins/apis/client/gen/model';

type IIsApiIntegration = (flags?: PartnerFeatureFlag[]) => boolean;

/**
 * パートナー機能フラグ配列から API 連携パートナーかどうかを判定する
 *
 * `ClientSideMenu`（サイドメニュー表示制御）と `LegacyPendingUserList`（行遷移制御）の
 * 2箇所で重複していた判定ロジックを共通化したもの。
 */
export const isApiIntegration: IIsApiIntegration = flags =>
  flags?.find(flag => flag.feature_key === 'api_integration')?.enabled ?? false;
